module.exports = __webpack_public_path__ + "static/media/2 5 Ordkjedetest-Riktig.d10f5858.mp3";